'use strict';

class SuperSettingsController {
    constructor(SSUtilService, SSUserService) {
        const self = this;

        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;
    }

}

SuperSettingsController.$inject = ['SSUtilService', 'SSUserService'];
app.controller('SuperSettingsController', SuperSettingsController);